import Loader from './loader';

export default class ChangePassword {
    constructor($form) {
        this.$form = $form;

        this.$oldPassword = $form.querySelector('#current-password');
        this.$newPassword = $form.querySelector('#new-password');
        this.$confirmPassword = $form.querySelector('#new-password-confirm');
        this.loader = (new Loader($form.querySelector('[data-loader]')));

        this.submit = this.submit.bind(this);
        this.fetch = this.fetch.bind(this);

        this.$form.addEventListener('submit', this.submit);
    }

    async submit(e) {
        e.preventDefault();

        if (!this.$oldPassword.value || !this.$newPassword.value) {
            return false;
        }

        if (this.$newPassword.value !== this.$confirmPassword.value) {
            let div = document.createElement("div");
            div.innerHTML = '<div class="form__error form__error--general">De wachtwoorden komen niet overeen.</div>';
            this.$form.prepend(div)
            return false;
        }

        if(this.$form.querySelector('.form__error')) {
            this.$form.querySelector('.form__error').remove();
        }

        this.loader.loading(true);

        const result = await this.fetch();

        this.loader.loading(false);
        if (result) {
            let div = document.createElement("div");
            div.innerHTML = '<div class="text--color-1"><strong>Je wachtwoord is met succes gewijzigd.</strong></div>';
            this.$form.prepend(div)
        } else {
            let div = document.createElement("div");
            div.innerHTML = '<div class="form__error form__error--general">Wachtwoord wijzigen is mislukt. Ben je zeker dat je het juiste wachtwoord hebt ingegeven?</div>';
            this.$form.prepend(div)
        }
    }

    async fetch() {
        const body = JSON.stringify({
            oldPassword: this.$oldPassword.value,
            newPassword: this.$newPassword.value
        });

        try {
            const request = await fetch(
                    placeholders.baseUri
                            ? placeholders.baseUri + '/ajax/type/65/change-password'
                            : 'ajax/type/65/change-password'
                    ,
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: body
                    }
            );
            const result = await request.json();
            return result;
        } catch (e) {
            console.log(e);
            // this.loader.loading(false);
        }
    }
}